var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-card'),_c('airport-transfer-widget',{staticClass:"mt-4"}),_c('how-it-works'),_c('highlights-card'),_c('foravila-guarantee')],1)}
var staticRenderFns = []

export { render, staticRenderFns }